(() => {
	// light mode or dark mode handler
	const lightDarkButton = document.getElementById("lightOrDarkMode");
	if (lightDarkButton) {
		lightDarkButton.addEventListener("click", () => {
			const body = document.getElementsByTagName("body")[0];
			if (body.classList.contains("dark")) {
				body.classList.remove("dark");
			} else {
				body.classList.add("dark");
			}
		});
	}
})();
